import { IconButton, Link } from "@mui/material";
import Iconify from "../../minimals/components/iconify";

const EditOrderInCalendarButton = ({ orderNumber, sx }: { orderNumber: string; sx?: object }) => {
  return (
    <Link href={`/calendar?ordernumber=${orderNumber}&mode=edit`} target="_blank" sx={sx}>
      <IconButton>
        <Iconify icon={"eva:edit-outline"} />
      </IconButton>
    </Link>
  );
};

export default EditOrderInCalendarButton;
